import React from 'react';
import './LoadingSpinner.css';

// Classes com prefixo `ls-` (namespaced): NCProcessing.css e AnalysisProgress.css
// definem o próprio `.spinner`/`@keyframes spin` e, como o CSS é global no CRA,
// colidiam com este componente (o container herdava largura de outra tela → a
// mensagem quebrava numa coluna estreita). O prefixo isola e resolve a colisão.
function LoadingSpinner({ size = 'medium', overlay = false, message = '' }) {
  const spinner = (
    <div className={`ls-spinner ls-spinner--${size}`}>
      <div className="ls-circle"></div>
      {message && <div className="ls-message">{message}</div>}
    </div>
  );

  if (overlay) {
    return (
      <div className="ls-overlay">
        <div className="ls-card">
          {spinner}
        </div>
      </div>
    );
  }

  return spinner;
}

export default LoadingSpinner;
